<template>
    <div class="fully-centered" style=" background: rgb(59, 173, 234); font-weight:bold; height: 100%; width: 100%; padding-top: 210px">
        <v-row>
            <v-col>
                <v-col class="text-center" style="overflow-y: hidden !important;">
                    <i class="fas fa-spinner fa-spin" style=" font-size: 100px!important; color: #ae9b3a!important"></i>
                </v-col>
                <v-col class="text-center">
                    <p style="font-size: 25px; color: white !important;">
                        {{ currentModel.settings.localizedContent['intake_transition_message'] }}
                    </p>
                </v-col>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    /*eslint-disable no-debugger*/
    import ContextualMixin from '../mixins/contextualMixin'
    export default {
        name: 'WalkinRedirect',
        mixins: [ContextualMixin],
        mounted() {
            this.$store.state.currentStep = 0;
            const redirectUrl = this.$store.state.jotFormRedirectUrl;
            if (redirectUrl) {
                this.$store.state.jotFormRedirectUrl = null;
                setTimeout(() => {
                    window.location.href = redirectUrl;
                }, 2000);
            } else {
                this.backToLobby();
            }
        }
    }
</script>